import { Pipe, PipeTransform } from '@angular/core';

@Pipe({name: 'hotkey'})

export class HotkeyPipe implements PipeTransform {
	transform(str: string): string {
		if (typeof str === 'undefined' || str === '') {
			return str;
		}


		str = str.replace('-', '\u2013');

		// Use same code as angular2-hotkeys
		// https://github.com/brtnshrdr/angular2-hotkeys/blob/master/src/hotkey.model.ts#L24
		if (window.navigator && window.navigator.platform.indexOf('Mac') >= 0) {
			str = str.replace('mod', '⌘');
			// option is substitute for alt
			str = str.replace('alt', '⌥');
			str = str.replace('option', '⌥');
			str = str.replace('shift', '⇧');
			str = str.replace('+', '');

			// For mac, make sure the keys are a fixed width
			const strArray = str.split('');
			strArray.forEach((item, i) => {
				strArray[i] = '<span>' + item + '</span>';
			});
			str = strArray.join('');

		} else {
			// Windows / Linux is a lot simpler...
			str = str.replace('mod', 'Ctrl');
			str = str.replace('alt', 'Alt');
			str = str.replace('option', 'Alt');
			str = str.replace('shift', 'Shift');
		}

		return str;
	}
}
